import { take, call, fork } from 'redux-saga/effects';
import * as api from '../../../utils/api';
import { fetchEntity } from '../../../store/saga';
import * as actions from './actions';

// Function to handle the API call
export function* postPTLFreightUpload(action) {
  const request = api.ptlFreightUploadRequest.bind(null, action.payload);
  yield call(fetchEntity, request, actions.postPTLFreightUpload, action.payload);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
// Watcher saga for handling the upload action
export function* watchPTLFreightUploadSaga() {
  while (true) {
    const action = yield take(actions.PTL_FREIGHT_UPLOAD.REQUEST); // Listening for the request action
    yield fork(postPTLFreightUpload, action); // Call the postPTLFreightUpload saga
  }
}